import PropTypes from 'prop-types';
import { Fragment } from 'react';
import * as seatStyles from '../SeatPicker/Seat.module.css';

const SeatMapLegend = ({ seatMap }) => (
  <div className="pb-10">
    <ul>
      {seatMap.legend && seatMap.legend.map((l) => (
        <Fragment key={`${l.type}-${l.title}`}>
          <li>
            <div className={`inline-block rounded-md w-10 h-10 ${seatStyles[l.type]}`}>
              {l.type === 'exit' ? '< >' : ' '}
            </div>
            <div className="inline-block align-top sm:leading-10 pl-2 w-3/4">
              {l.title}
            </div>
          </li>
        </Fragment>
      ))}
    </ul>
  </div>
);

SeatMapLegend.propTypes = {
  seatMap: PropTypes.shape({
    legend: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  }).isRequired,
};

export default SeatMapLegend;
